/* eslint-disable prefer-const, no-unused-expressions, no-undef, no-unused-vars, no-shadow */
import domReady from '@wordpress/dom-ready';
import { gsap } from 'gsap';
import {
  verticalLoop,
  horizontalLoop,
} from '../../../assets/scripts/main/gsap.js';

domReady(() => {
  const contentWrapper = document.querySelector('.areas-map__content-wrapper');
  const content = document.querySelector('.areas-map__content');
  const listContainer = document.querySelector('.areas-map__list-container');

  const mm = gsap.matchMedia();
  let horizontalAnimation;
  let verticalAnimation;

  function getAnimationsDisabled() {
    return document.documentElement.classList.contains('no-animation');
  }

  // Mobile breakpoint (max-width: 992px) - horizontal marquee
  mm.add('(max-width: 992px)', () => {
    if (contentWrapper && content && listContainer) {
      contentWrapper.classList.remove('container-wide');
      content.classList.add('container-wide');
      listContainer.classList.add('container-wide');
    }

    horizontalAnimation = horizontalLoop(
      '.areas-map__logos-wrapper--horizontal .areas-map__logo-slide',
      {
        repeat: -1,
        center: true,
        speed: 0.2,
        paddingRight: 20,
        paused: getAnimationsDisabled(),
      }
    );

    return () => {
      gsap.set('.areas-map__logos-wrapper--horizontal .areas-map__logo-slide', {
        clearProps: 'all',
      });
    };
  });

  // Desktop breakpoint (min-width: 993px) - vertical marquee
  mm.add('(min-width: 993px)', () => {
    if (contentWrapper && content && listContainer) {
      contentWrapper.classList.add('container-wide');
      content.classList.remove('container-wide');
      listContainer.classList.remove('container-wide');
    }

    verticalAnimation = verticalLoop(
      '.areas-map__logos-wrapper--vertical .areas-map__logo-slide',
      {
        repeat: -1,
        center: true,
        speed: 0.2,
        paddingBottom: 40,
        paused: getAnimationsDisabled(),
      }
    );

    return () => {
      gsap.set('.areas-map__logos-wrapper--vertical .areas-map__logo-slide', {
        clearProps: 'all',
      });
    };
  });

  // Listen for animation setting changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class'
      ) {
        const animationsDisabled = getAnimationsDisabled();

        if (horizontalAnimation) {
          if (animationsDisabled) {
            horizontalAnimation.pause();
          } else {
            horizontalAnimation.play();
          }
        }

        if (verticalAnimation) {
          if (animationsDisabled) {
            verticalAnimation.pause();
          } else {
            verticalAnimation.play();
          }
        }
      }
    });
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });

  //----- Areas map hover effect -----//
  const areasList = document.querySelectorAll('[data-area]');
  const areasSvg = document.querySelector('#areas-map__svg');
  const areasSvgGroup = areasSvg.children;

  const areasByDataset = {};
  const svgElementsById = {};

  areasList.forEach((area) => {
    const areaDataset = area.dataset.area;
    if (!areasByDataset[areaDataset]) areasByDataset[areaDataset] = [];
    areasByDataset[areaDataset].push(area);
  });

  Array.from(areasSvgGroup).forEach((svgElement) => {
    if (svgElement.id) {
      svgElementsById[svgElement.id] = svgElement;
    }
  });

  areasList.forEach((area) => {
    const areaDataset = area.dataset.area;
    const svgElement = svgElementsById[areaDataset];

    if (!svgElement) return;

    area.addEventListener('mouseover', () => {
      svgElement.classList.add('active');
      area.classList.add('active');
    });

    area.addEventListener('mouseout', () => {
      svgElement.classList.remove('active');
      area.classList.remove('active');
    });
  });

  Object.entries(svgElementsById).forEach(([id, svgElement]) => {
    const relatedAreas = areasByDataset[id] || [];

    svgElement.addEventListener('mouseover', () => {
      svgElement.classList.add('active');
      relatedAreas.forEach((area) => area.classList.add('active'));
    });

    svgElement.addEventListener('mouseout', () => {
      svgElement.classList.remove('active');
      relatedAreas.forEach((area) => area.classList.remove('active'));
    });
  });
});
